import { BindingProps, linkModel } from 'framework/mobx-integration';
import { getStore, GridStoreHolder } from 'controls/grid/utils/getStore';
import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { TimePeriod } from 'controls/react/form/timePeriodSelector';

export function linkGridAdditionalPayload<DataEntry extends GridDataEntry>(
	holder: GridStoreHolder<DataEntry>,
	name: string,
): BindingProps<TimePeriod> {
	const store = getStore(holder);
	if (!store) return;

	return linkModel(store.state.customPayload, name) as BindingProps<TimePeriod>;
}
